import { render, staticRenderFns } from "./NewLabor.vue?vue&type=template&id=383198ba&scoped=true"
import script from "./NewLabor.vue?vue&type=script&lang=js"
export * from "./NewLabor.vue?vue&type=script&lang=js"
import style0 from "./NewLabor.vue?vue&type=style&index=0&id=383198ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383198ba",
  null
  
)

export default component.exports